import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.13.0_patch_hash=vqjrgo3cjrje5mjjjciwfs2hgq_@parcel+watcher@2.5.0_@types+node@20.10.1_d_gxvhhwhqa32jek4a5scifwt2t4/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}